// Static build identifier - this stays the same during runtime
// but will be different after each build/deployment
const BUILD_VERSION = process.env.REACT_APP_VERSION || 'v1.0.0';

// Check if a new version is available and reload if needed
export const checkVersion = () => {
  const storedVersion = sessionStorage.getItem('app_version');
  const hasReloaded = sessionStorage.getItem('has_reloaded');
  
  // If versions don't match and we haven't already reloaded once
  if (storedVersion && storedVersion !== BUILD_VERSION && !hasReloaded) {
    console.log('New version detected, reloading...');
    sessionStorage.setItem('has_reloaded', 'true');
    sessionStorage.setItem('app_version', BUILD_VERSION);
    window.location.reload(true);
  } else {
    // Clear the reload flag and update version
    sessionStorage.removeItem('has_reloaded');
    sessionStorage.setItem('app_version', BUILD_VERSION);
  }
};

// Handle chunk load errors
export const handleChunkError = (error) => {
  if (!error) return false;
  
  const isChunkError = error.name === 'ChunkLoadError' || 
                       /Loading chunk [\d]+ failed/.test(error.message) ||
                       /ChunkLoadError/.test(error.toString()) ||
                       /Failed to fetch dynamically imported module/.test(error.message);
  
  if (isChunkError) {
    const hasReloadedForChunk = sessionStorage.getItem('chunk_error_reload');
    
    // Only reload once for chunk errors to prevent infinite loops
    if (!hasReloadedForChunk) {
      console.log('Chunk load error detected, reloading...');
      sessionStorage.setItem('chunk_error_reload', 'true');
      
      // Clear any stale cache entries
      if ('caches' in window) {
        caches.keys().then(names => {
          names.forEach(name => caches.delete(name));
        });
      }
      
      setTimeout(() => {
        window.location.reload(true);
      }, 100);
      return true;
    } else {
      // If we already reloaded once, clear the flag and show error
      console.error('Chunk error persists after reload');
      sessionStorage.removeItem('chunk_error_reload');
      return false;
    }
  }
  return false;
};